import type { i18nStringType } from "../../i18n/i18nString";
import type { PayType } from "@spwn/types";

const PAYMENT_TYPE_I18N_KEY: Record<PayType, i18nStringType> = {
  Card: "settlementHistory.paymentMethod.card",
  Member: "settlementHistory.paymentMethod.card",
  CVS: "settlementHistory.paymentMethod.cvs",
  Phone: "settlementHistory.paymentMethod.phone",
  Free: "settlementHistory.paymentMethod.free",
  Venue: "settlementHistory.paymentMethod.venue",
  Stripe: "settlementHistory.paymentMethod.stripe",
  PayPal: "settlementHistory.paymentMethod.payPal",
  PayPay: "settlementHistory.paymentMethod.payPay",
};

export const getPaymentType = (paymentType: PayType | null): i18nStringType => {
  if (paymentType == null) return "settlementHistory.paymentMethod.unknown";
  return (
    PAYMENT_TYPE_I18N_KEY[paymentType] ??
    "settlementHistory.paymentMethod.unknown"
  );
};
